import React, {useEffect, useMemo, useState} from "react";
import {MDBBtn, MDBTable, MDBTableBody, MDBTableHead} from "mdb-react-ui-kit";
import {getFormatedDate} from "../../utils/uitls";
import {ERR_BAD_REQUEST, getData} from "../../network/network";
import {AxiosError} from "axios";
import {ResponseOuter, TaskHistory} from "../../models/task";

type HistoryProps = {
    taskId: string
}

export const History = (props: HistoryProps) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('')
    const [data, setData] = useState<Array<TaskHistory>>([])
    
    useEffect(() => {
        setLoading(true)
        getData({
            url: '/api/task/get-task-history',
            data: {
                task_id: props.taskId,
            },
            onSuccess: (data: ResponseOuter<Array<TaskHistory>>) => {
                setData(data.data)
                setLoading(false)
                setError('')
            },
            onError: (err: AxiosError) => {
                switch (err.code) {
                    case ERR_BAD_REQUEST:
                        setError("something went wrong")
                        break
                    default:
                        setError("service unavailable")
                }
                setLoading(false)
            }
        })
    }, [props.taskId]);

    const listComponent = useMemo(() => {
        let count = 0
        const result = []
        for (let i = data.length - 1; i >= 0; i--) {
            const item = data[i]
            if (item.file) {
                count++
            }
            result.push((<tr>
                <td>
                    <p className='fw-normal'>
                        {item.email}
                    </p>
                </td>
                <td>
                    {item.action_type !== 'status_change' ?
                        <p className='fw-normal'>
                            <b>{item.action_type === 'created' ? 'Created ' : 'Updated '}</b>
                            a task
                        </p>
                        : <p className='fw-normal'>
                            <b>{item.status !== 0 ? 'Approved' : 'Reject'}</b>
                            {' as a ' + item.user_role}
                            { item.is_admin ? ' by admin' : ''}
                        </p>
                    }
                </td>
                <td>
                    {getFormatedDate(item.created_at)}
                </td>
                <td>
                    {
                        item.file ?
                            <>
                                <MDBBtn
                                    color='link'
                                    rounded
                                    size='sm'
                                    href={'https://api.doctivolifesciences.com/api/view-file?file_path=' + item.file}
                                    target="_blank">
                                    {`View (V${count})`}
                                </MDBBtn>
                                <MDBBtn
                                    color='link'
                                    rounded
                                    size='sm'
                                    href={'https://api.doctivolifesciences.com/uploads/' + item.file}
                                    target="_blank">
                                    {`Download (V${count})`}
                                </MDBBtn>
                            </> : <></>
                    }
                </td>
                <td>
                    <div dangerouslySetInnerHTML={{__html: item.comment}}/>
                </td>
            </tr>))
        }
        return result.reverse()
    }, [data])
    if (loading) {
        return (<div className="container mt-4">
                <div className="row justify-content-center align-items-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        )
    }

    if (error.length > 0) {
        return (<div className="container mt-4">
                <div className="row justify-content-center align-items-center">
                    {error}
                </div>
            </div>
        )
    }

    if (data.length === 0) {
        return (<div className="container mt-4">
                <div className="row justify-content-center align-items-center">
                    No data available
                </div>
            </div>
        )
    }

    return (
        <div className="container">
            <MDBTable align='middle'>
                <MDBTableHead>
                    <tr>
                        <th scope='col'>Email</th>
                        <th scope='col'>Action</th>
                        <th scope='col'>Date</th>
                        <th scope='col'>File</th>
                        <th scope='col'>Comment</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {listComponent}
                </MDBTableBody>
            </MDBTable>

        </div>
    )
}

